
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Vue from "vue"
import type { BadgeState, UserProgressResponse } from "@/types/progression"
import ProgressBenefitCard from "@/components/progression/ProgressBenefitCard.vue"
import ProgressActionChecklist from "@/components/progression/ProgressActionChecklist.vue"
import {
  buildBadgeDescription,
  buildBadgeTitle,
  buildChecklistActions,
  buildImpactedBenefits,
} from "@/utils/progressBadgeView"
import type { TranslateFn } from "@/utils/progressionI18n"
import { formatBadgeProgressCount } from "@/utils/progressionI18n"

export default Vue.extend({
  name: "ProgressBadgeModal",
  emits: ["input"],
  components: {
    ProgressBenefitCard,
    ProgressActionChecklist,
  },
  props: {
    value: { type: Boolean, default: false },
    badgeSlug: { type: String, default: "" },
    progressData: { type: Object as () => UserProgressResponse | null, default: null },
  },
  computed: {
    badge(): BadgeState | null {
      if (!this.badgeSlug || !this.progressData) {
        return null
      }
      return this.progressData.badges.find((item) => item.slug === this.badgeSlug) ?? null
    },
    badgeTitle(): string {
      const t: TranslateFn = (key) => this.$vuetify.lang.t(key)
      return buildBadgeTitle(t, this.badgeSlug, this.progressData)
    },
    badgeDescription(): string {
      const t: TranslateFn = (key) => this.$vuetify.lang.t(key)
      return buildBadgeDescription(t, this.badgeSlug, this.progressData)
    },
    progressCountLabel(): string {
      const t: TranslateFn = (key) => this.$vuetify.lang.t(key)
      if (!this.badge) {
        return ""
      }
      return formatBadgeProgressCount(t, this.badge)
    },
    checklistTitle(): string {
      return this.$vuetify.lang.t("$vuetify.progression_checklist_title")
    },
    impactedBenefits() {
      const t: TranslateFn = (key) => this.$vuetify.lang.t(key)
      return buildImpactedBenefits(t, this.badge, this.progressData)
    },
    checklistActions() {
      const t: TranslateFn = (key) => this.$vuetify.lang.t(key)
      return buildChecklistActions(t, this.badge, { enrichConnexion: true })
    },
  },
})
